import type { Feature } from '@luna/gatekeeper';

export const temporaryDeactivation: Feature = {
    enabled: true,
    _description:
        'Displays fields of application section in the bank card settings page and credit card functions page',
};
